import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from 'ui';
import { ExpandLess, ExpandMore } from 'ui/icons';

import { SidebarLink, type SidebarLinkProps } from './SidebarLink';

type SidebarItemProps = {
  label: string;
  icon: React.ReactNode;
  links: SidebarLinkProps[];
  isExpanded: boolean;
  onToggleExpand: () => void;
};

export const SidebarItem = ({ label, icon, links, isExpanded, onToggleExpand }: SidebarItemProps) => {
  return (
    <div>
      <ListItemButton onClick={onToggleExpand} sx={{ borderRadius: 1 }}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={label} />
        {isExpanded ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {links.map((link) => {
            return (
              <SidebarLink
                key={link.label}
                label={link.label}
                href={link.href}
                indent
                isLegacy={link.isLegacy}
                title={link.title}
              />
            );
          })}
        </List>
      </Collapse>
    </div>
  );
};
